<template>
  <section class="tmf flex-all-center">
    <a
      :href="`https://tokyo42195.org/${langPath}`"
      class="tmf__link"
      target="_blank"
      rel="noopener"
    >
      <img
        src="../../../assets/images/logo-tmf.svg"
        alt="TOKYO MARATHON FOUNDATION"
      />
    </a>
    <a
      :href="`https://www.marathon.tokyo/${langPath}`"
      class="tmf__link"
      target="_blank"
      rel="noopener"
    >
      <img
        src="../../../assets/images/tmf/tokyomarathon.svg"
        alt="Tokyo Marathon"
      />
    </a>
    <a
      :href="`https://legacyhalf.tokyo/${langPath}`"
      class="tmf__link"
      target="_blank"
      rel="noopener"
    >
      <img
        src="../../../assets/images/tmf/tokyolegacyhalfmarathon.svg"
        alt="Tokyo Legacy Half Marathon"
      />
    </a>
    <a
      href="https://onetokyo.org/"
      class="tmf__link"
      target="_blank"
      rel="noopener"
    >
      <img src="../../../assets/images/tmf/onetokyo.svg" alt="ONE TOKYO" />
    </a>
    <a
      href="https://www.voluntainer.jp/"
      class="tmf__link"
      target="_blank"
      rel="noopener"
    >
      <img
        src="../../../assets/images/tmf/voluntainer.svg"
        alt="東京マラソン財団オフィシャルボランティアクラブ"
      />
    </a>
    <a
      :href="`https://www.marathon.tokyo/${langPath}charity/`"
      class="tmf__link"
      target="_blank"
      rel="noopener"
    >
      <img
        src="../../../assets/images/tmf/run-with-heart.svg"
        alt="Run with Heart"
      />
    </a>
    <a
      :href="`https://www.sportslegacy.jp/${langPath}`"
      class="tmf__link"
      target="_blank"
      rel="noopener"
    >
      <img
        src="../../../assets/images/tmf/sports-legacy.svg"
        alt="東京マラソン財団スポーツレガシー事業"
      />
    </a>
  </section>
</template>

<script>
export default {
  props: {
    langPath: {
      type: String,
    },
  },
  name: "TokyoMarathonFoundation",
};
</script>

<style scoped>
.tmf {
  padding: 100px 15px 30px 15px;
  text-align: center;
  &__link {
    &:hover {
      opacity: 0.4;
      transition-duration: 0.3s;
    }
    &:not(:first-of-type) {
      margin: 0 0 0 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/top/TokyoMarathonFoundation.vue